import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../components/action-buttons/action-buttons.types';
import { ContextMenuItem } from '../../buildingBlocks/context-menu/context-menu.types';
import {
  ShipmentsDownloadMenuAction,
  ShipmentsPageActionButton,
  ShipmentsPageActionName,
  ShipmentsPageActionTooltip,
} from './shipments.types';

export const SHIPMENTS_FIELDS_KEY = 'SHIPMENTS_MODULE_FORMKEY';

export const SHIPMENTS_DETAIL_FIELDS_KEY = 'SHIPMENTS_DETAIL_FORMKEY';

export const SHIPMENTS_COLUMN_LIST = 'column_list-shipments';

export const SELECT_COLUMNS_DIALOG_ID = 'shipments-select-columns-dialog';

export const SHIPMENTS_DETAIL_COLUMN_LIST = 'column_list-shipments-detail';

export const SELECT_COLUMNS_DETAIL_DIALOG_ID = 'shipments-detail-select-columns-dialog';

export const templateFilePath = '/downloads/shipments/templates/MRN_SHIPMENT_TEMPLATE.xlsx';

export const SHIPMENTS_DOWNLOAD_MENU_ITEMS: ContextMenuItem[] = [
  {
    icon: 'download',
    label: 'Invoice PDFs (zip)',
    name: ShipmentsDownloadMenuAction.InvoicePdfsZip,
  },
];

export const shipmentsActionButtons: ShipmentsPageActionButton[] = [
  {
    color: ButtonColor.Blue,
    icon: 'download',
    menuItems: SHIPMENTS_DOWNLOAD_MENU_ITEMS,
    name: ShipmentsPageActionName.DOWNLOAD_INVOICES,
    tooltipKey: 'commits.download',
  },
  {
    icon: 'text_snippet',
    name: ShipmentsPageActionName.DOWNLOAD_TEMPLATE,
    tooltipKey: ShipmentsPageActionTooltip.DOWNLOAD_TEMPLATE,
    visibilityRule: 'shipmentsMrnUpload',
  },
  {
    color: ButtonColor.Blue,
    icon: 'upload',
    name: ShipmentsPageActionName.UPLOAD,
    tooltipKey: ShipmentsPageActionTooltip.UPLOAD,
    visibilityRule: 'shipmentsMrnUpload',
  },
  chatbotActionButton(ShipmentsPageActionName.CHATBOT),
];

/** Namespace the shipments column captions are translated from, by field name. */
export const SHIPMENTS_COLUMN_LABEL_PREFIX = 'defaultFields.shipments-module.';

export const SHIPMENTS_TEST_IDS = {
  columnSelect: 'shipments-column-select',
  detailColumnSelect: 'shipments-detail-column-select',
} as const;
